import type { FC } from "react";

import { LoadingSpinner } from "../ProgressSpinner/LoadingSpinner.tsx";
import type { LoadingSpinnerIntent } from "../ProgressSpinner/settings.ts";
import style from "./Buttons.module.css";

interface LoadingIconProps {
  intent?: LoadingSpinnerIntent;
}

export const LoadingIcon: FC<LoadingIconProps> = ({ intent }) => (
  <div className={style.loading_icon} data-testid="loading-icon">
    <LoadingSpinner intent={intent} size={18} />
  </div>
);
